import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { List } from "lucide-react";

/**
 * EmailBroadcastTable — Broadcast Performance section.
 *
 * DASH-EMAIL-P1-IMPL-008: retired the fictional per-Broadcast catalog
 * (`brd-*` ids, hand-typed counts, client-computed rates) this table used
 * to render — DASH-EMAIL-P1-CHAR-007 found none of it authoritative.
 * A real per-Broadcast breakdown would require either N bounded calls
 * against the existing `/summary?broadcast_id=X` endpoint (once per real
 * governed Broadcast) or a new backend `$group by broadcast_id` addition —
 * both explicitly out of scope for this slice (§7: "Do NOT ... perform an
 * N-call fan-out ... create a backend grouping endpoint"). This component
 * now unconditionally renders an honest "not yet available" state instead
 * of accepting or displaying any row data. Keeps its original
 * `data-testid="email-broadcast-table"` (an existing, widely-used
 * "Performance has finished loading" signal elsewhere in the test suite)
 * so removing the fabricated content doesn't also break that unrelated
 * synchronization contract.
 */
export default function EmailBroadcastTable() {
  return (
    <Card className="glass border-white/10" data-testid="email-broadcast-table">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg text-slate-100">
          <List className="h-5 w-5 text-indigo-400" />
          Broadcast Performance
        </CardTitle>
      </CardHeader>
      <CardContent className="p-8 text-center text-slate-400" data-testid="email-broadcast-table-unavailable">
        <p className="text-lg">Broadcast-level performance is not yet available</p>
        <p className="text-sm mt-2">
          A real, per-Broadcast breakdown requires authoritative data this Dashboard does not yet have. This
          section will populate once that data source exists.
        </p>
      </CardContent>
    </Card>
  );
}
